export default __webpack_public_path__ + "static/media/DSC_0543.95bf743f.webp";